import React from "react";
import PropTypes from "prop-types";
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Box,
  useTheme,
  Chip
} from "@mui/material";
import { USDollar } from "../../utils/functions/Helpers";
import { tokens } from "../../theme";

const AddOnCard = ({ addOn }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Card
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        borderRadius: "16px",
        overflow: "hidden",
        bgcolor: theme.palette.mode === "dark" ? colors.primary[400] : "#FFFFFF",
        boxShadow: `0 4px 20px ${colors.primary[900]}1A`,
        transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: `0 12px 30px ${colors.primary[900]}26`,
        }
      }}
    >
      <Box sx={{ position: 'relative' }}>
        <CardMedia
          component="img"
          height="160"
          image={addOn?.media?.mediaUrl || "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?auto=format&fit=crop&q=80&w=400"}
          alt={addOn?.name}
          sx={{ objectFit: 'cover' }}
        />
        <Chip
          label={addOn?.category}
          size="small"
          sx={{
            position: 'absolute',
            top: 12,
            right: 12,
            bgcolor: `${colors.greenAccent[500]}CC`,
            color: colors.primary[500],
            fontWeight: "700",
            backdropFilter: "blur(4px)",
            fontFamily: "Josefin Sans"
          }}
        />
      </Box>

      <CardContent sx={{ flexGrow: 1, p: 2, display: 'flex', flexDirection: 'column' }}>
        <Typography variant="h5" fontWeight="700" sx={{ mb: 1, color: colors.grey[100], fontFamily: "Josefin Sans", lineClamp: 1, display: '-webkit-box', WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
          {addOn?.name}
        </Typography>

        <Typography variant="body2" sx={{ mb: 2, color: colors.grey[300], flexGrow: 1, lineClamp: 2, display: '-webkit-box', WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
          {addOn.description || "Enhance your event with this premium service."}
        </Typography>

        <Box sx={{ mt: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', pt: 1 }}>
          <Box display="flex" alignItems="center" gap={0.5}>
            <Typography variant="h5" fontWeight="800" color={colors.greenAccent[500]}>
              {USDollar.format(addOn?.price || 0)}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

AddOnCard.propTypes = {
  addOn: PropTypes.object.isRequired,
};

export default AddOnCard;
